
import {useParamsContextProvider} from '../../../../../hooks/ParamsContextProvider';
import {useNavigate} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import {TABS_FOODIE} from '../../Model/Models';
import routes from '../../../../../Routes/routes';
import {useDispatch, useSelector} from 'react-redux';
import {VIEW_TYPE} from '../../../../../enums/ViewType';
import {SimpleSearch} from '../../../../../reduxToolkit/Search/SearchApi';
import DropDownMenuProfile from '../../../../../components/DropDown/DropDownMenuProfile';
import DropDownMenuItem from '../../../../../components/DropDown/DropDownMenuItem';
import {
    DeleteIconsOptions,
    UpdateIconsOptions,
} from '../../../../../components/buttons/IconButtons';
import TableFunction from '../../../../../components/table/TableFunction';
import {TABLES} from '../../../../../Apis/Tables';
import {permissionObj} from '../../../../../Helpers/permission';
import {
    DEFAULT_LEFT,
    LEFT_FIRST_COLUMN_WITH_CHECKBOX,
    SEARCH_MODEL
} from '../../../../../components/table/Model/TableModel';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param useState selectForDelete: required
 * @param useState setSelectForDelete: required
 * @returns {{navigate, paramsContext, pagination: ((function(): *)|*), isAllChecked: boolean, columns: [{field: string, label: string}], permission: *, handleDeleteAll: handleDeleteAll, rowsPerPage: number, searchResults: unknown, menuModalShow: boolean, t: TFunction<"translation", undefined>, DEV: *, handleCheckboxChange: handleCheckboxChange, itemSelected: unknown, RenderDetails: (function(*)), handleRowExpand: handleRowExpand, setParamsContext, renderOptionsMenu: (function(*)), page: number}}
 *
 */
const ShiftsApp = ({selectForDelete, setSelectForDelete, modified, setModified, option}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { paramsContext, setParamsContext } = useParamsContextProvider();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [searchResults, setSearchResults] = useState(null);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [search, setSearch] = useState(false);
    const [bodyForExport, setBodyForExport] = useState('');
    const [searchElement, setSearchElement] = useState('');
    let searchId = 'txt_st_search_shifts'
    let view = VIEW_TYPE.LIST;
    const deletePermission = (DEV || permission?.includes(permissionObj?.WEB_FOODIE_SHIFT_DELETE));
    const leftPosition = deletePermission ? LEFT_FIRST_COLUMN_WITH_CHECKBOX : DEFAULT_LEFT;


    const columns = [
        { field: 'name', label: 'schedule', fixed: true, left: leftPosition }
    ];

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({page: page, size: rowsPerPage, model: TABLES.FOODIE_SHIFT, key: searchElement, view: view});
        setBodyForExport(body)
        dispatch(SimpleSearch({ body })).then(({ payload: { data: { data, success } } }) => {
                if (success === true) {
                    setSearchResults(data);
                }
            }
        );
    }

    const {
        t,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        rowsPerPage,
        handleRowExpand,
        handleMenuToggle,
        handleClose,
        openMenu
    } = TableFunction({
        selectedList: selectForDelete,
        setSelectedList: setSelectForDelete,
        data:searchResults,
        view: VIEW_TYPE.LIST.name,
        labelRowsPerPage:'shifts_per_page',
        fixedPagination:false,
        hasContainer:true,
        setIsAllChecked:setIsAllChecked,

        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    /**
     * useEffect to redirect to the shift creation view.
     */
    useEffect(() => {
        if(paramsContext && paramsContext?.tabIndex == TABS_FOODIE.SCHEDULES.INDEX && paramsContext?.modalCreate)
            navigate(`${routes.foodieShift.create}`);
    }, [paramsContext, paramsContext?.modalCreate]);

    /**
     * Function to open the deletion modal.
     * @param item
     */
    const handleDelete = (item) => {
        setSelectForDelete([item.id])
        setParamsContext(prev => ({
            ...prev,
            modalDelete: true
        }));
    };

    /**
     * Rendering of the table menu options.
     * @param row
     * @returns {JSX.Element}
     */
    const renderOptionsMenu = (row) => {
        return (
            <>
                <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle}
                                     menuId={`menu-${row.id}`} isAccordion={true}>
                    {(DEV || permission?.includes(permissionObj?.WEB_FOODIE_SHIFT_UPDATE)) &&
                    <DropDownMenuItem
                        index={row.id}
                        handleClose={handleClose}
                        name={t('update')}
                        url={`${routes.foodieShift.update}${row.id}`}
                        icon={<UpdateIconsOptions/>}
                    />
                    }

                    {(DEV || permission?.includes(permissionObj?.WEB_FOODIE_SHIFT_DELETE)) &&
                    <DropDownMenuItem
                        index={row.id}
                        handleClose={handleClose}
                        name={t('delete')}
                        fontColor='font-color-error-600'
                        iconColor={"icon-color-error-code-600"}
                        click={() => {
                            handleDelete(row);
                        }}
                        icon={<DeleteIconsOptions/>}
                    />
                    }

                </DropDownMenuProfile>
            </>
        )
    };

    return {
        t,
        DEV,
        permission,
        searchId,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        rowsPerPage,
        columns,searchResults,
        renderOptionsMenu,
        handleRowExpand,
        setBodyForExport,
        setSearchResults,
        setSearchElement,
        setSimpleSearch,
        search,
        setSearch,
        searchElement,
        deletePermission
    }

}

export default ShiftsApp;
